import { LOCAL_STORAGE_KEY } from '@shared/constants';
import { useEffect, useState } from 'react';

export function useFingerprint() {
    const [visitorId, setVisitorId] = useState<string | null>(() => {
        try {
            return localStorage.getItem(LOCAL_STORAGE_KEY.FINGERPRINT) || null;
        } catch {
            return null;
        }
    });

    useEffect(() => {
        if (visitorId) return;

        let cancelled = false;

        import('@fingerprintjs/fingerprintjs')
            .then(({ default: FingerprintJS }) => FingerprintJS.load())
            .then((fp) => fp.get())
            .then((result) => {
                if (cancelled) return;
                const newVisitorId = result.visitorId;
                try {
                    localStorage.setItem(LOCAL_STORAGE_KEY.FINGERPRINT, newVisitorId);
                } catch {
                    // Storage unavailable — fingerprint won't be persisted or sent in headers
                }
                setVisitorId(newVisitorId);
            })
            .catch(() => {
                // Fingerprinting is best-effort — swallow chunk load / ad-blocker failures
            });

        return () => {
            cancelled = true;
        };
    }, [visitorId]);

    return visitorId;
}
